module.exports = __webpack_public_path__ + "static/media/sf-test-3.8de06c40.mp3";